// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__EXcFM","content":"styles_content__27R1Q","selectAll":"styles_selectAll__nGUI_"};